import React, { Component } from 'react';

import styles from './styles.less';

interface Props {
	pageIndex: number;
	currentPageIndex: number;
	children: React.ReactNode;
}

export default class PagerPage extends Component<Props> {
	static defaultProps = {
		pageIndex: 0,
		currentPageIndex: 0,
	};

	render() {
		const { pageIndex, currentPageIndex, children } = this.props;
		const left = `${String((pageIndex - currentPageIndex) * 100)}%`;

		return (
			<div className={styles.page} style={{ left }}>
				{children}
			</div>
		);
	}
}
